"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startInterceptingConsole = exports.serviceWrapper = exports.refConsole = void 0;
const logger_interface_1 = require("./logger.interface");
// eslint-disable-next-line no-restricted-globals
const refWindow = window;
exports.refConsole = refWindow.console;
const FILTER_WARNING_ERRORS_REACT = [
    '^Warning: Received .* for a non-boolean attribute .*',
    '^Warning: React does not recognize the .* prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase .* instead. If you accidentally passed it from a parent component, remove it from the DOM element..*',
    '^Using kebab-case for css properties in objects is not supported. Did you mean.*',
    '^Warning: A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components',
    '^Warning: validateDOMNesting\\(\\.\\.\\.\\): .* cannot appear as a descendant of .*',
    '^Warning: Failed .* type: .*',
].join('|');
const serviceWrapper = (getServiceData, cb) => (message, args) => {
    cb(message, Object.assign(Object.assign({}, args), getServiceData()));
};
exports.serviceWrapper = serviceWrapper;
const consoleOverrideApps = ['modal'];
const interceptConsole = (type, args) => {
    const logType = logger_interface_1.LogsType[type];
    if (type !== logger_interface_1.LogLevel.ERROR) {
        const messages = args.filter((val) => typeof val === 'string');
        const printArgs = (args.length > 1 &&
            (typeof args[0] === 'string' ? args.slice(1, args.length) : args)) ||
            [];
        exports.refConsole[logType](...messages, {
            function: 'interceptConsole',
            filename: 'LoggerService',
        }, ...printArgs);
    }
    if (type === logger_interface_1.LogLevel.ERROR) {
        if (typeof (args === null || args === void 0 ? void 0 : args[0]) === 'string' &&
            new RegExp(FILTER_WARNING_ERRORS_REACT).test(args[0])) {
            exports.refConsole.warn(...args);
        }
        else {
            exports.refConsole[logType](...args);
        }
    }
};
const startInterceptingConsole = (appName) => {
    if (consoleOverrideApps.indexOf(appName.toLowerCase()) !== -1) {
        refWindow.console = Object.assign(Object.assign({}, refWindow.console), { log: (...args) => interceptConsole(logger_interface_1.LogLevel.LOG, args), info: (...args) => interceptConsole(logger_interface_1.LogLevel.INFO, args), warn: (...args) => interceptConsole(logger_interface_1.LogLevel.WARN, args), error: (...args) => interceptConsole(logger_interface_1.LogLevel.ERROR, args) });
    }
};
exports.startInterceptingConsole = startInterceptingConsole;
